import React from 'react';

const ContactSocials = () => {
    const icons = {
        github: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="Coding-Apps-Websites-Programming-Hold-Code--Streamline-Pixel" className='fill-secondary w-[3rem]'>
  <desc>
    Coding Apps Websites Programming Hold Code Streamline Icon: https://streamlinehq.com
  </desc>
  <title>coding-apps-websites-programming-hold-code</title>
  <g>
    <path d="M22.86 12.00375H24v5.715h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M21.7125 17.71875h1.1475v2.2800000000000002h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M21.7125 9.71625h1.1475v2.2874999999999996h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M20.572499999999998 19.99875h1.1400000000000001v2.2874999999999996h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M20.572499999999998 8.568750000000001h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M19.424999999999997 22.28625h1.1475v1.1400000000000001H19.424999999999997Z" strokeWidth="0.75"></path>
    <path d="M19.424999999999997 15.431249999999999h1.1475v2.2874999999999996H19.424999999999997Z" strokeWidth="0.75"></path>
    <path d="M19.424999999999997 12.00375h1.1475v2.2800000000000002H19.424999999999997Z" strokeWidth="0.75"></path>
    <path d="M19.424999999999997 7.428749999999999h1.1475v1.1400000000000001H19.424999999999997Z" strokeWidth="0.75"></path>
    <path d="M18.285 17.71875h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M18.285 8.568750000000001h1.1400000000000001v3.435h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M18.285 4.00125h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M17.145 18.85875h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M17.145 14.283750000000001h2.2800000000000002v1.1475h-2.2800000000000002Z" strokeWidth="0.75"></path>
    <path d="M17.145 5.14125h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M17.145 2.86125h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M15.997499999999999 15.431249999999999h1.1475v1.1400000000000001h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M15.997499999999999 6.28875h1.1475v1.1400000000000001h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M15.997499999999999 1.71375h1.1475v1.1475h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M14.857499999999998 22.28625h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M14.857499999999998 16.57125h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M14.857499999999998 7.428749999999999h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M14.857499999999998 0.57375h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M13.7175 17.71875h1.1400000000000001v4.5675h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M12.57 0.57375h1.1475v2.2874999999999996h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M11.43 2.86125h1.1400000000000001v3.4275h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M10.2825 6.28875h1.1475v2.2800000000000002h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M9.1425 17.71875h1.1400000000000001v4.5675h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M8.0025 22.28625h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M8.0025 16.57125h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M8.0025 7.428749999999999h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M8.0025 0.57375h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M6.855 15.431249999999999h1.1475v1.1400000000000001H6.855Z" strokeWidth="0.75"></path>
    <path d="M6.855 6.28875h1.1475v1.1400000000000001H6.855Z" strokeWidth="0.75"></path>
    <path d="M6.855 1.71375h1.1475v1.1475H6.855Z" strokeWidth="0.75"></path>
    <path d="M5.715 18.85875h1.1400000000000001v1.1400000000000001H5.715Z" strokeWidth="0.75"></path>
    <path d="M4.574999999999999 14.283750000000001h2.2800000000000002v1.1475H4.574999999999999Z" strokeWidth="0.75"></path>
    <path d="M5.715 5.14125h1.1400000000000001v1.1475H5.715Z" strokeWidth="0.75"></path>
    <path d="M5.715 2.86125h1.1400000000000001v1.1400000000000001H5.715Z" strokeWidth="0.75"></path>
    <path d="M4.574999999999999 17.71875h1.1400000000000001v1.1400000000000001H4.574999999999999Z" strokeWidth="0.75"></path>
    <path d="M4.574999999999999 8.568750000000001h1.1400000000000001v3.435H4.574999999999999Z" strokeWidth="0.75"></path>
    <path d="M4.574999999999999 4.00125h1.1400000000000001v1.1400000000000001H4.574999999999999Z" strokeWidth="0.75"></path>
    <path d="M3.4275 22.28625H4.574999999999999v1.1400000000000001H3.4275Z" strokeWidth="0.75"></path>
    <path d="M3.4275 15.431249999999999H4.574999999999999v2.2874999999999996H3.4275Z" strokeWidth="0.75"></path>
    <path d="M3.4275 12.00375H4.574999999999999v2.2800000000000002H3.4275Z" strokeWidth="0.75"></path>
    <path d="M3.4275 7.428749999999999H4.574999999999999v1.1400000000000001H3.4275Z" strokeWidth="0.75"></path>
    <path d="M2.2874999999999996 19.99875h1.1400000000000001v2.2874999999999996H2.2874999999999996Z" strokeWidth="0.75"></path>
    <path d="M2.2874999999999996 8.568750000000001h1.1400000000000001v1.1475H2.2874999999999996Z" strokeWidth="0.75"></path>
    <path d="M1.1400000000000001 17.71875h1.1475v2.2800000000000002H1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M1.1400000000000001 9.71625h1.1475v2.2874999999999996H1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M0 12.00375h1.1400000000000001v5.715H0Z" strokeWidth="0.75"></path>
  </g>
</svg>
        ),
        linkedin: (
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="Logo-Linkedin--Streamline-Pixel" className='fill-secondary w-[3rem]'>
  <desc>
    Logo Linkedin Streamline Icon: https://streamlinehq.com
  </desc>
  <title>logo-linkedin</title>
  <g>
    <path d="M22.8525 2.2874999999999996H24v19.424999999999997h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M21.7125 21.7125h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M21.7125 1.1400000000000001h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M20.565 3.4275h1.1475v17.145h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M2.2800000000000002 22.86h19.4325V24H2.2800000000000002Z" strokeWidth="0.75"></path>
    <path d="M3.4275 20.572499999999998h17.137500000000003v1.1400000000000001H3.4275Z" strokeWidth="0.75"></path>
    <path d="m17.137500000000003 11.43 -1.1400000000000001 0 0 -1.1475 -2.2874999999999996 0 0 1.1475 -1.1400000000000001 0 0 -1.1475 -2.2874999999999996 0 0 6.862500000000001 2.2874999999999996 0 0 -3.4275 1.1400000000000001 0 0 -1.1475 1.1475 0 0 1.1475 1.1400000000000001 0 0 3.4275 2.2874999999999996 0 0 -4.574999999999999 -1.1475 0 0 -1.1400000000000001z" strokeWidth="0.75"></path>
    <path d="M5.7075000000000005 10.2825h2.2874999999999996v6.862500000000001H5.7075000000000005Z" strokeWidth="0.75"></path>
    <path d="M5.7075000000000005 6.855h2.2874999999999996v2.2874999999999996H5.7075000000000005Z" strokeWidth="0.75"></path>
    <path d="M3.4275 2.2874999999999996h17.137500000000003v1.1400000000000001H3.4275Z" strokeWidth="0.75"></path>
    <path d="M2.2800000000000002 0h19.4325v1.1400000000000001H2.2800000000000002Z" strokeWidth="0.75"></path>
    <path d="M2.2800000000000002 3.4275h1.1475v17.145H2.2800000000000002Z" strokeWidth="0.75"></path>
    <path d="M1.1400000000000001 21.7125h1.1400000000000001v1.1475H1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M1.1400000000000001 1.1400000000000001h1.1400000000000001v1.1475H1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M0 2.2874999999999996h1.1400000000000001v19.424999999999997H0Z" strokeWidth="0.75"></path>
  </g>
</svg>
        ),
        instagram: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="Photography-Picture-Polaroid--Streamline-Pixel" className='fill-secondary w-[3rem]'>
  <desc>
    Photography Picture Polaroid Streamline Icon: https://streamlinehq.com
  </desc>
  <title>photography-picture-polaroid</title>
  <g>
    <path d="M22.29 2.8575h1.1400000000000001v19.4325h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M2.8575 22.29h19.4325v1.1400000000000001H2.8575Z" strokeWidth="0.75"></path>
    <path d="M20.0025 1.7175h1.1400000000000001v18.285h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="m17.715 10.86 -2.2874999999999996 0 0 1.1400000000000001 2.2874999999999996 0 0 3.4275 1.1475 0 0 -11.4225 -1.1475 0 0 6.855z" strokeWidth="0.75"></path>
    <path d="m15.4275 14.287500000000001 -1.1400000000000001 0 0 1.1400000000000001 -10.2825 0 0 1.1475 13.71 0 0 -1.1475 -2.2874999999999996 0 0 -1.1400000000000001z" strokeWidth="0.75"></path>
    <path d="M14.287500000000001 12h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M13.1475 13.1475h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="m13.1475 9.712499999999999 2.2800000000000002 0 0 -1.1400000000000001 1.1475 0 0 -2.2874999999999996 -1.1475 0 0 -1.1400000000000001 -2.2800000000000002 0 0 1.1400000000000001 -1.1475 0 0 2.2874999999999996 1.1475 0 0 1.1400000000000001z" strokeWidth="0.75"></path>
    <path d="M12 12h1.1475v1.1475H12Z" strokeWidth="0.75"></path>
    <path d="M10.86 10.86H12V12h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M9.72 9.712499999999999h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M7.4325 8.5725h2.2874999999999996v1.1400000000000001H7.4325Z" strokeWidth="0.75"></path>
    <path d="M6.285 9.712499999999999h1.1475v1.1475H6.285Z" strokeWidth="0.75"></path>
    <path d="M5.1450000000000005 10.86h1.1400000000000001V12H5.1450000000000005Z" strokeWidth="0.75"></path>
    <path d="M4.005 2.8575h13.71v1.1475H4.005Z" strokeWidth="0.75"></path>
    <path d="m4.005 13.1475 1.1400000000000001 0 0 -1.1475 -1.1400000000000001 0 0 -7.995 -1.1475 0 0 11.4225 1.1475 0 0 -2.2800000000000002z" strokeWidth="0.75"></path>
    <path d="M1.7175 0.5700000000000001h18.285v1.1475H1.7175Z" strokeWidth="0.75"></path>
    <path d="M1.7175 20.0025h18.285v1.1400000000000001H1.7175Z" strokeWidth="0.75"></path>
    <path d="M0.5700000000000001 1.7175h1.1475v18.285H0.5700000000000001Z" strokeWidth="0.75"></path>
  </g>
</svg>
        ),
        email: (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="Email-Mail-Open-Address--Streamline-Pixel" className='fill-secondary w-[3rem]'>
  <desc>
    Email Mail Open Address Streamline Icon: https://streamlinehq.com
  </desc>
  <title>email-mail-open-address</title>
  <g>
    <path d="m22.86 9.1425 0 -1.1400000000000001 -1.1475 0 0 -1.1475 -1.1400000000000001 0 0 -2.2800000000000002 -1.1400000000000001 0 0 9.1425 1.1400000000000001 0 0 -1.1475 1.1400000000000001 0 0 -1.1400000000000001 1.1475 0 0 10.2825 1.1400000000000001 0 0 -12.57 -1.1400000000000001 0z" strokeWidth="0.75"></path>
    <path d="M21.7125 21.7125h1.1475v1.1475h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M2.2874999999999996 22.86h19.424999999999997V24H2.2874999999999996Z" strokeWidth="0.75"></path>
    <path d="M18.285 13.7175h1.1475v1.1400000000000001h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M17.145 19.4325h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M17.145 14.857499999999998h1.1400000000000001v1.1400000000000001h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M15.997499999999999 18.285h1.1475v1.1475h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M15.997499999999999 15.997499999999999h1.1475v1.1475h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M15.997499999999999 8.0025h1.1475v3.4275h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M14.857499999999998 6.855h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M8.0025 17.145h7.995v1.1400000000000001H8.0025Z" strokeWidth="0.75"></path>
    <path d="M13.7175 11.43h2.2800000000000002v1.1400000000000001h-2.2800000000000002Z" strokeWidth="0.75"></path>
    <path d="m13.7175 8.0025 -3.4275 0 0 1.1400000000000001 2.2800000000000002 0 0 2.2874999999999996 1.1475 0 0 -3.4275z" strokeWidth="0.75"></path>
    <path d="M10.290000000000001 11.43h2.2800000000000002v1.1400000000000001h-2.2800000000000002Z" strokeWidth="0.75"></path>
    <path d="M9.1425 5.715h5.715v1.1400000000000001h-5.715Z" strokeWidth="0.75"></path>
    <path d="M9.1425 13.7175h5.715v1.1400000000000001h-5.715Z" strokeWidth="0.75"></path>
    <path d="M9.1425 9.1425h1.1475v2.2874999999999996h-1.1475Z" strokeWidth="0.75"></path>
    <path d="M8.0025 12.57h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M8.0025 6.855h1.1400000000000001v1.1475h-1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="M6.855 18.285h1.1475v1.1475H6.855Z" strokeWidth="0.75"></path>
    <path d="M6.855 15.997499999999999h1.1475v1.1475H6.855Z" strokeWidth="0.75"></path>
    <path d="M6.855 8.0025h1.1475v4.5675H6.855Z" strokeWidth="0.75"></path>
    <path d="M5.715 19.4325h1.1400000000000001v1.1400000000000001H5.715Z" strokeWidth="0.75"></path>
    <path d="M5.715 14.857499999999998h1.1400000000000001v1.1400000000000001H5.715Z" strokeWidth="0.75"></path>
    <path d="m19.4325 4.574999999999999 0 -1.1475 -2.2874999999999996 0 0 -1.1400000000000001 -1.1475 0 0 -1.1475 -1.1400000000000001 0 0 -1.1400000000000001 -5.715 0 0 1.1400000000000001 -1.1400000000000001 0 0 1.1475 -1.1475 0 0 1.1400000000000001 -2.2800000000000002 0 0 1.1475 14.857499999999998 0z" strokeWidth="0.75"></path>
    <path d="M4.574999999999999 13.7175h1.1400000000000001v1.1400000000000001H4.574999999999999Z" strokeWidth="0.75"></path>
    <path d="M1.1400000000000001 21.7125h1.1475v1.1475H1.1400000000000001Z" strokeWidth="0.75"></path>
    <path d="m1.1400000000000001 11.43 1.1475 0 0 1.1400000000000001 1.1400000000000001 0 0 1.1475 1.1475 0 0 -9.1425 -1.1475 0 0 2.2800000000000002 -1.1400000000000001 0 0 1.1475 -1.1475 0 0 1.1400000000000001 -1.1400000000000001 0 0 12.57 1.1400000000000001 0 0 -10.2825z" strokeWidth="0.75"></path>
  </g>
</svg>
        ),
      };
  const modules = [
    {
      title: 'Github',
      description: 'Ver más de mis proyectos programados.',
      to: 'https://github.com/13djune',
      icon: 'github'
    },
    {
      title: 'LinkedIn',
      description: 'Vamos a conectar.',
      to: 'https://www.linkedin.com/in/bel%C3%A9n-castillo-chac%C3%B3n-11540925a/',
      icon: 'linkedin'
    },
    {
      title: 'Instagram',
      description: '¡Sígueme en mis redes sociales!',
      to: 'https://instagram.com/404.june',
      icon: 'instagram'
    },
    {
      title: 'Email',
      description: 'Envíame un correo electrónico.',
      to: 'mailto:belencastillocha@gmail.com',
      icon: 'email'
    }
  ];

  return (
    <div className="socials grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4 max-w-6xl mx-auto w-full">
   {modules.map((module, index) => (
  <div
    key={index}
    className="pixelbutton soci  transition-transform transform hover:bg-[#bcfeeb64] hover:scale-105 bg-[#bcfeeb64] dark:bg-[#22866531] bg-cover"
  >
    <a 
      href={module.to} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="block p-4 text-text"
    >
      <div className="flex items-center mb-2">
        <span className="text-3xl mr-2">
          {icons[module.icon]} 
        </span>
        <div className='flex flex-col'>
        <h4 className="text-xl font-bold font-bit text-secondary">{module.title}</h4>
      <p className="text-text line-clamp-2">{module.description}</p>

        </div>
      </div>
    </a>
  </div>
))}
    </div>
  );
};

export default ContactSocials;